import { LeftOutlined, RightOutlined } from '@ant-design/icons'
import classNames from 'classnames'
import type { ReactNode } from 'react'

import cn from './PriorityFiltersRow.module.scss'
import { usePairScroll } from './usePairScroll'

interface PriorityFiltersRowProps {
  itemsCount: number
  children: ReactNode
}

function PriorityFiltersRow({ itemsCount, children }: PriorityFiltersRowProps) {
  const { viewportRef, canScrollLeft, canScrollRight, scrollPair } =
    usePairScroll(itemsCount)
  const hasOverflow = canScrollLeft || canScrollRight

  return (
    <div className={cn.row}>
      {hasOverflow && (
        <button
          type="button"
          className={cn.arrow}
          aria-label="Прокрутить фильтры влево"
          disabled={!canScrollLeft}
          onClick={() => scrollPair('left')}
        >
          <LeftOutlined />
        </button>
      )}
      <div
        className={classNames(
          cn.viewport,
          canScrollLeft && cn.fadeLeft,
          canScrollRight && cn.fadeRight
        )}
        ref={viewportRef}
      >
        {children}
      </div>
      {hasOverflow && (
        <button
          type="button"
          className={cn.arrow}
          aria-label="Прокрутить фильтры вправо"
          disabled={!canScrollRight}
          onClick={() => scrollPair('right')}
        >
          <RightOutlined />
        </button>
      )}
    </div>
  )
}

export default PriorityFiltersRow
